export default __webpack_public_path__ + "static/media/Panjeree-4.5c2ad029.gif";